<template>
	<div>
		<k-modal
			@ok="newAction"
			@hidden="hideModal"
			id="newActionModal"
			:title="title"
			:okTitle="btnText"
			:okDisabled="disableOk"
			okVariant="info"
			:cancelTitle="$t('buttons.cancel')"
			cancelVariant="outline-info"
			size="md"
		>
			<template v-slot:content>
				<k-crud @checkChange="checkChange" :fields="modalFieldsStructure" :data="response" ref="stepKCrud" />
				<div v-if="shouldShowDestinations()">
					<k-select-list
						v-for="(exit, index) in response.destinations"
						:key="exit.idStep"
						:options="exitStepsList(exit.idStep)"
						:value="exit.idStep"
						@input="onSelectStep($event, index)"
						valueField="idStep"
						textField="name"
						@deleteItem="deleteDestinationStep"
						:hideIcon="hideIcon"
					/>
				</div>
				<!-- Atualmente, não temos as questões de fluxo paralelo -->
				<!-- <div
					v-if="response.type == 'Step' || response.type == 'Integration'"
					class="addDestinationStep"
					@click="addDestinationStep"
				>
					<b-icon icon="plus-circle" class="addDestinationIcon" />
					{{ $t("modals.newAction.addNewDestinationStep") }}
				</div> -->
				<b-col cols="12" class="mt-4">
					<b-row>
						<b-col cols="12">
							<b-form v-on:submit.prevent>
								<b-form-group :label="$t('modals.newAction.buttonColor')">
									<b-dropdown block no-caret :variant="response.buttonColor || 'info'" boundary="window" menu-class="w-100" toggle-class="d-flex align-items-center justify-content-between color-picker-toggle">
										<template #button-content>
											<span class="d-flex align-items-center">
												<b-badge :variant="response.buttonColor || 'info'" class="mr-2">&nbsp;&nbsp;&nbsp;</b-badge>
												{{ (colorOptions.find((c) => c.value === response.buttonColor) || colorOptions[0]).label }}
											</span>
											<svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 4 5" style="flex-shrink:0">
												<path fill="#212529" d="M2 0L0 2h4zm0 5L0 3h4z" />
											</svg>
										</template>
										<b-dropdown-item v-for="color in colorOptions" :key="color.value" link-class="pl-2" @click="response.buttonColor = color.value">
											<b-badge :variant="color.value" class="mr-2">&nbsp;&nbsp;&nbsp;</b-badge>
											{{ color.label }}
										</b-dropdown-item>
									</b-dropdown>
								</b-form-group>
							</b-form>
						</b-col>
					</b-row>
				</b-col>
				<k-crud @checkChange="checkChange" :fields="secondModalFieldsStructure" :data="response" ref="stepKCrud" />
			</template>
		</k-modal>
	</div>
</template>

<script>
import KCrud from "../ui/KCrud.vue";
import KModal from "./KModal.vue";
import KSelectList from "../ui/KSelectList.vue";

export default {
	props: {
		type: {
			type: String
		},
		steps: {
			type: Array
		},
		actualStep: {
			type: Object
		}
	},
	components: { KCrud, KModal, KSelectList },
	data() {
		let response = this.getInitialResponse();
		let standartAction = false;

		return {
			response,
			standartAction,
			stepActionNotificationsList: [],
			actionTypes: [],
			colorOptions: [
				{ value: "info", label: "Info" },
				{ value: "success", label: "Success" },
				{ value: "warning", label: "Warning" },
				{ value: "danger", label: "Danger" },
				{ value: "secondary", label: "Secondary" },
				{ value: "light", label: "Light" },
				{ value: "dark", label: "Dark" }
			]
		};
	},
	created() {
		this.actionTypes = [
			{ value: this.$ActionType.Step, text: this.$t("commons.destinationTypeEnum.step") },
			{ value: this.$ActionType.Concluded, text: this.$t("commons.destinationTypeEnum.concluded") },
			{ value: this.$ActionType.Canceled, text: this.$t("commons.destinationTypeEnum.canceled") },
			{ value: this.$ActionType.Integration, text: this.$t("commons.destinationTypeEnum.integration") },
			{ value: this.$ActionType.Returned, text: this.$t("commons.destinationTypeEnum.returned") }
		];
	},
	computed: {
		title() {
			return this.type == "new" ? this.$t("modals.newAction.title.new") : this.$t("modals.newAction.title.edit");
		},
		btnText() {
			return this.type == "new" ? this.$t("commons.add") : this.$t("buttons.save");
		},
		disableOk() {
			let allFilled = true;
			let responseType = this.response.type;

			this.response.destinations.forEach((destination) => {
				if (destination.idStep == 0 && responseType == this.$ActionType.Step) allFilled = false;
			});

			return (
				!this.response.name ||
				!responseType ||
				(responseType == this.$ActionType.Step && this.response.destinations.length == 0) ||
				!allFilled
			);
		},
		modalFieldsStructure() {
			let modalFieldsStructure = [
				{
					rowNum: 0,
					width: "12",
					name: "name",
					label: this.$t("commons.name"),
					type: "text",
					validation: this.$validations.required
				},
				{
					rowNum: 1,
					width: "12",
					name: "type",
					label: this.$t("modals.newAction.destinationType"),
					type: "dropdown",
					valueKey: "value",
					valueText: "text",
					returnKey: true,
					validation: this.$validations.required,
					options: this.actionTypes
				}
			];
			return modalFieldsStructure;
		},
		secondModalFieldsStructure() {
			let modalFieldsStructure = [
				{
					rowNum: 1,
					width: "12",
					name: "standartAction",
					label: this.$t("modals.newAction.standardAction"),
					type: "checkbox"
				},
				{
					rowNum: 2,
					width: "12",
					name: "sendEmail",
					label: this.$t("modals.newAction.sendEmail"),
					type: "checkbox",
					isVisible: this.shouldShowSendEmailCheckBox()
				},
				{
					rowNum: 3,
					width: "12",
					name: "stepActionNotifications",
					label: this.$t("commons.actors"),
					type: "dropdownCheckbox",
					text: this.$t("commons.actors"),
					isVisible: this.response.sendEmail ? true : false,
					entityList: this.stepActionNotificationsList
				}
			];
			return modalFieldsStructure;
		},
		hideIcon() {
			return this.response.destinations.length < 2;
		}
	},
	methods: {
		shouldShowDestinations() {
			return (
				this.response.type === this.$ActionType.Step ||
				this.response.type === this.$ActionType.Integration ||
				this.response.type === this.$ActionType.Returned
			);
		},
		onSelectStep(selectedIdStep, index) {
			const destinationStep = this.steps.find((s) => s.idStep === selectedIdStep);
			this.response.destinations[index].idStep = selectedIdStep;
			this.response.destinations[index].idStepDestination = destinationStep?.registeredIdStep;
		},
		shouldShowSendEmailCheckBox() {
			const destinationStepsIds = this.response.destinations.map(({ idStep }) => idStep);
			const hasSystemActor = this.steps
				.filter(({ idStep }) => destinationStepsIds.includes(idStep))
				.some(({ actor }) => actor && actor.id === this.$FillerActor.PUBLIC_CONSULTATIONS_ACTOR);

			if (hasSystemActor) this.response.sendEmail = false;

			return !hasSystemActor && this.response.type != this.$ActionType.Integration;
		},
		exitStepsList(actualSelected) {
			let destinationsId = this.response.destinations.map((d) => d.idStepDestination);
			return this.steps.filter((step) => destinationsId.indexOf(step.idStep) == -1 || step.idStep == actualSelected);
		},
		addDestinationStep() {
			this.response.destinations.push({
				idStep: 0,
				idStepDestination: 0
			});
		},
		deleteDestinationStep(destinationStep) {
			let obj = this.response.destinations.find((o) => o.idStep == destinationStep);
			let index = this.response.destinations.indexOf(obj);
			this.response.destinations.splice(index, 1);
		},
		newAction(preventDefault) {
			let action = {
				idStepAction: this.response.idStepAction,
				name: this.response.name,
				destinations: this.response.destinations.filter((d) => d.idStep != 0),
				type: this.response.type,
				standartAction: this.response.standartAction,
				sendEmail: this.response.sendEmail,
				buttonColor: this.response.buttonColor,
				stepActionNotifications: this.response.stepActionNotifications
			};

			let allOk = this.$refs.stepKCrud.validateAllFields();
			if (allOk) {
				action.stepActionNotifications = this.setSelectedStepActors();
				this.$emit(this.type == "new" ? "newAction" : "editAction", action);
			} else {
				preventDefault();
			}
		},
		setSelectedStepActors: function () {
			let selectedsActors = this.stepActionNotificationsList.filter((actor) => actor.label).map((actor) => actor.id);
			return selectedsActors;
		},
		checkChange(fieldName) {
			if (fieldName == "standartAction" && this.standartAction && this.response.standartAction) {
				this.response.standartAction = false;
				this.$functions.displayError(this, this.$t("modals.newAction.standardActionAlreadyDefined"));
			}
		},
		setStandartActionOnModal(haveStandartAction) {
			this.standartAction = haveStandartAction;
		},
		setActionOnModal(action) {
			let stepDestination = [];
			stepDestination.push({ idStep: 0 });
			this.response.idStepAction = action.idStepAction;
			this.response.name = action.name;
			this.response.type = action.type;
			this.response.standartAction = action.standartAction;
			this.response.sendEmail = action.sendEmail;
			this.response.buttonColor = action.buttonColor;
			this.response.destinations = action.destinations ? action.destinations : stepDestination;
			this.activeActors = action.actors;
			this.setStepActorsOnData(action.stepActionNotifications);
		},
		setStepActorsOnData(selectedStepAction) {
			if (this.stepActionNotificationsList.length || !this.response?.stepActionNotifications) {
				return;
			}

			this.stepActionNotificationsList = this.setStepActors(selectedStepAction);
		},
		getSelectedDestinationActorId() {
			const firstDestination = this.response.destinations?.[0];
			if (!firstDestination?.idStep) {
				return null;
			}

			const destinationStep = this.steps.find((step) => step.idStep === firstDestination.idStep);
			return destinationStep?.actor?.id || null;
		},
		removeActorFromNotificationsList(actorIdToRemove) {
			if (!actorIdToRemove || !this.stepActionNotificationsList.length) {
				return;
			}

			this.stepActionNotificationsList = this.stepActionNotificationsList.filter(
				(actor) => actor.id !== actorIdToRemove
			);
		},
		setStepActors(selectedStepAction) {
			let stepActionNotificationsList = [];
			this.activeActors?.forEach((actor) => {
				let label = selectedStepAction?.includes(actor.id);
				stepActionNotificationsList.push({
					id: actor.id,
					name: actor.name + " ", // TODO: Essa concatenação de strings vazias ocorre porque o componente <KDropdownCheckbox> utiliza o atributo name como chave. Por isso, se houver mais de uma listagem com o mesmo name, todos os dropdowns acabam compartilhando o mesmo comportamento, funcionando como se fossem um único componente.
					label: label
				});
			});

			return stepActionNotificationsList;
		},
		getInitialResponse() {
			return {
				idStepAction: -1,
				name: "",
				type: "",
				standartAction: false,
				sendEmail: false,
				buttonColor: null,
				destinations: [],
				stepActionNotifications: [],
				activeActors: []
			};
		},
		hideModal() {
			this.response = this.getInitialResponse();
			this.stepActionNotificationsList = [];
		}
	}
};
</script>

<style scoped>
.addDestinationIcon {
	margin-right: 8px;
}
.addDestinationStep {
	cursor: pointer;
	margin-inline: 17px;
}

.addDestinationStep:hover {
	font-weight: 500;
	color: black;
}

::v-deep .color-picker-toggle:focus,
::v-deep .show .color-picker-toggle {
	border-color: #adb5bd !important;
	box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.25) !important;
	outline: 0;
}
</style>
